import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';

import Button from '../Parts/Button';

type AnnouncementPopupProps = {
	title: string;
	body: string;
	imageUrl: string | null;
	preview?: boolean | undefined;
	/** Hidden for popups that only ever open from a deliberate click, where opting out is meaningless. */
	allowHideUntilUpdate?: boolean | undefined;
	/** Distinguishes the checkbox when more than one popup can be on screen (editor previews). */
	checkboxId?: string | undefined;
	onClose: (hideUntilUpdate: boolean) => void;
};

const AnnouncementPopup = ({
	title,
	body,
	imageUrl,
	preview = false,
	allowHideUntilUpdate = true,
	checkboxId = 'cta-popup-hide-until-update',
	onClose,
}: AnnouncementPopupProps) => {
	const [hideUntilUpdate, setHideUntilUpdate] = useState(false);

	return (
		<Modal
			show
			centered
			backdrop="static"
			onHide={() => onClose(hideUntilUpdate)}
			className='m-auto'
			contentClassName="border border-secondary rounded"
		>
			<Modal.Body className="px-4 pb-4 pt-3">
				<h2 className="text-primary text-center fw-medium mb-3 m-0">{title}</h2>
				<div
					className={
						'd-flex align-items-center justify-content-center mx-auto mb-3 '
						+ 'border border-secondary overflow-hidden bg-light'
					}
					style={{ width: 'min(508px, 100%)', height: 269 }}
				>
					{imageUrl ? (
						<img
							src={imageUrl}
							alt=""
							className="w-100 h-100"
							style={{ objectFit: 'cover' }}
						/>
					) : (
						<span className="text-secondary">Image</span>
					)}
				</div>

				<div
					className="text-center mb-3"
					style={{ lineHeight: '23px', whiteSpace: 'pre-wrap' }}
				>
					{body}
				</div>

				<div className="text-center mb-4" style={{ lineHeight: '23px' }}>
					If you need any help with a quote at any given time please reach out
					&nbsp;to your territory manager and/or inside sales(417)-553-0504
				</div>

				<div
					className={'d-flex align-items-center gap-3 '
						+ (allowHideUntilUpdate ? 'justify-content-between' : 'justify-content-end')}
				>
					{allowHideUntilUpdate ? (
						<Form.Check
							type="checkbox"
							id={checkboxId}
							className="text-secondary m-0"
							style={{ lineHeight: '23px' }}
							label="Do not show this again"
							checked={hideUntilUpdate}
							onChange={(e) => setHideUntilUpdate(e.target.checked)}
						/>
					) : null}
					<Button color="green" onClick={() => onClose(preview ? false : hideUntilUpdate)}>
						Close
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AnnouncementPopup;
